import React from 'react';
import PropTypes from 'prop-types';
import { ModalViewProvider } from 'Views/Onboarding/Contexts/ModalViewContext';
import { RefreshAccountsProvider } from 'Views/Onboarding/Contexts/RefreshAccountsContext';
import { UnlinkProvider } from 'Views/Onboarding/Contexts/UnlinkContext';
import { SnackbarContextProvider } from 'Context/SnackbarContext';
import { ModalProvider } from 'Views/Page/Contexts/ModalContext';
import SurveyContainer from './SurveyContainer';
import { SurveyProvider } from './SurveyContext';

const Survey = ({
  clientResource,
  onStepChange,
  ...rest
}) => {
  return (
    <SurveyProvider
      clientResource={clientResource}
      onStepChange={onStepChange}
      {...rest}
    >
      <ModalProvider>
        <RefreshAccountsProvider>
          <ModalViewProvider>
            <SnackbarContextProvider>
              <UnlinkProvider>
                <SurveyContainer
                  clientResource={clientResource}
                />
              </UnlinkProvider>
            </SnackbarContextProvider>
          </ModalViewProvider>
        </RefreshAccountsProvider>
      </ModalProvider>
    </SurveyProvider>
  );
};

Survey.defaultProps = {
  onboardingStepCollection: null,
  onStepChange: null,
};

Survey.propTypes = {
  clientResource: PropTypes.object.isRequired,
  onboardingStepCollection: PropTypes.object,
  onStepChange: PropTypes.func,
};

export default Survey;
